import { atom } from "recoil";

export const ScheduleZoomOutState = atom<number | null>({
  key: "scheduleZoomOutState",
  default: null,
});
